import React, { useMemo } from 'react';
import Hero from '../components/Hero';
import Banner from '../components/Banner';
import AffiliateSection from '../components/AffiliateSection';
import AmazonBanner from '../components/AmazonBanner';
import ProductGrid from '../components/ProductGrid';
import { PRODUCTS } from '../data/products';

export default function HomePage({ onProductClick, searchQuery }) {
  const filtered = useMemo(() => {
    if (!searchQuery.trim()) return PRODUCTS.filter(p => !p.isPlaceholder);
    const q = searchQuery.toLowerCase();
    return PRODUCTS.filter(
      p => !p.isPlaceholder &&
        (p.name.toLowerCase().includes(q) || p.description?.toLowerCase().includes(q))
    );
  }, [searchQuery]);

  return (
    <>
      <Hero />
      <section id="productos" style={{ maxWidth: '1200px', margin: '0 auto', padding: '48px 20px' }}>
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontFamily: 'var(--font-display)',
            fontSize: 'clamp(1.6rem, 3vw, 2.2rem)',
            color: 'var(--green-dark)',
            marginBottom: '8px',
          }}>
            🏪 Todos los productos
          </h2>
          <p style={{ color: 'var(--gray-400)', fontSize: '14px' }}>
            {filtered.length} producto{filtered.length !== 1 ? 's' : ''} encontrado{filtered.length !== 1 ? 's' : ''}
          </p>
        </div>

        {filtered.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '80px 20px', color: 'var(--gray-400)' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔍</div>
            <h3 style={{ fontWeight: 700, marginBottom: '8px' }}>Sin resultados</h3>
            <p>Intenta con otra búsqueda o categoría</p>
          </div>
        ) : (
          <ProductGrid
            products={filtered}
            onProductClick={onProductClick}
            showPlaceholders={false}
          />
        )}
      </section>

      <Banner />
      <AmazonBanner />
      <AffiliateSection />
    </>
  );
}
